<template>
    <CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        
        <div class="row px-4 mb-2 mx-0" id="content-timelinetable">
            <table class="table table-bordered border-main mb-0 px-0 text-xs">
                <caption class=" my-0 py-0"></caption>
                <thead class="">
                    <tr class="text-white border-white text-center bg-main">
                        <th scope="col">N°</th>
                        <th scope="col">FECHA</th>
                        <th scope="col">NOTA</th>
                        <th scope="col">ACCIÓN</th>
                    </tr>
                </thead>
                <tbody v-if="this.despachos.length > 0">
                    <tr v-for="(proc, index) in this.despachos" :key="index" class="px-1 border-bottom">
                        <td class="text-center"><span>{{ index + 1 }}</span></td>
                        <td class="text-center"><span>{{ formatDate(proc.date) }} </span></td>
                        <td class="text-center"><span>{{ proc.note }} </span></td>
                        <td class="text-center">
                            <button @click="pdfRecipe(proc)"
                                class="btn btn-primary btn-sm rounded-circle bootom "
                                title="Pdf Recetas">
                                <i class="fas fa-solid fa-file-pdf"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tbody class=" text-center" v-else>
                <tr>
                    <td colspan="4" class=" text-center">
                        <strong> No hay resultados</strong>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
        
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import { mapActions } from "vuex";
import moment from "moment";

export default {
    name: "c-medico-modal-proc-invasivo-view",

    data() {
        return {
            swal: null,
            
        }
    },
    components: {
        CModal,
        SweetAlert
    },
    props: {
        title: String,
        boo_modal: Boolean,
        despachos:Array
    },
   
   
    methods: {
        ...mapActions(['get', 'post']),
        
        mtdclosemodal() {
            this.$emit('mtdclosemodalview');
        },
       
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY | HH:mm:ss") : "";
        },

        pdfRecipe(item){
            window.open(
                        this.$store.getters.get__url + "/viewpdfDocEpp/" + item.id,
                        "_blank"
                );
        }
    },
}
</script>